import { useState } from 'react';
import { CurrencyTypeEnum } from '../../../../../../model/currency_type.enum';
import { OptionConfig, WindowTenorEnum } from './use-series-manager';

const formatTokenLabel = (token: string) => token.replace(/(_)?(USDC|USDT|USD)$/g, '');

const TOKENS = [
  CurrencyTypeEnum.BITCOIN,
  CurrencyTypeEnum.ETHEREUM,
  CurrencyTypeEnum.XRP,
  CurrencyTypeEnum.SOL,
];

export type ImpliedOptionsArray = [OptionConfig<CurrencyTypeEnum>, OptionConfig<WindowTenorEnum>];

export const useImpliedOptions = () => {
  const [token, setToken] = useState<CurrencyTypeEnum>(CurrencyTypeEnum.BITCOIN);
  const [tenor, setTenor] = useState<WindowTenorEnum>(WindowTenorEnum.W1);

  const tokenOptions = TOKENS.map((t) => ({
    label: formatTokenLabel(t),
    value: t,
  }));

  const tenorOptions = [
    { label: '1W', value: WindowTenorEnum.W1 },
    { label: '2W', value: WindowTenorEnum.W2 },
    { label: '1M', value: WindowTenorEnum.M1 },
    { label: '3M', value: WindowTenorEnum.M3 },
    { label: '9M', value: WindowTenorEnum.M9 },
  ];

  const options: ImpliedOptionsArray = [
    { key: 'token', value: token, setValue: setToken, label: 'Token', options: tokenOptions },
    { key: 'tenor', value: tenor, setValue: setTenor, label: 'Tenor', options: tenorOptions },
  ];

  return {
    options,
  };
};
